import { useState } from 'react';
import CloseIcon from 'assets/icons/close.svg';

const DISMISSED_KEY = 'coming_soon_banner_dismissed';

const ComingSoonBanner = () => {
  const [isDismissed, setIsDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === 'true'
  );

  const onDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className='w-full bg-yellow-100 flex items-start justify-center gap-3 px-6 py-3'>
      <span className='shrink-0 mt-0.5 bg-yellow-300 text-black text-xs font-bold uppercase px-2 py-1 rounded'>
        Coming soon
      </span>
      <p className='min-w-0 flex-1 text-sm font-light text-black'>
        This site includes historical software benchmarks as of Sep 1, 2026.
        AI metrics and filters from our{' '}
        <a
          href='https://www.iconiq.com/growth/reports/2026-state-of-scaling'
          target='_blank'
          rel='noopener noreferrer'
          style={{
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            color: '#E8A026',
            textDecorationLine: 'none',
            borderBottom: '1px solid #E8A026',
            paddingBottom: '1px'
          }}
        >
          State of Scaling report
        </a>{' '}
        will be added in the coming months.
      </p>
      <img
        className='w-4 h-4 mt-0.5 cursor-pointer shrink-0'
        src={CloseIcon}
        alt='Dismiss'
        onClick={onDismiss}
      />
    </div>
  );
};

export default ComingSoonBanner;
